import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { LOGGED_IN_USER } from "../../util/constants";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const user = JSON.parse(sessionStorage.getItem(LOGGED_IN_USER));
    if (user != null) {
      let authReq: any;
      if (req.body !== null && req.body !== undefined) {
        if (req.body.lastModified !== undefined) {
          return next.handle(req);
        } else {
          authReq = this.clientheaders(req, user);
        }
      }
      authReq = this.clientheaders(req, user);
      return next.handle(authReq);
    }
    return next.handle(req);
  }

  clientheaders(req, user) {
    return req.clone({
      headers: req.headers.set("Authorization", user.token),
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/token.interceptor.ts